/* eslint-disable complexity */
import moment from 'moment';

const roles = {
    ADMINISTRADOR: 'ADMINISTRADOR',
    APODERADO: 'APODERADO',
    APORTANTE_CONYUGE: 'APORTANTE_CONYUGE',
    APORTANTE_FAMILIAR: 'APORTANTE_FAMILIAR',
    AUTORIZADO: 'AUTORIZADO',
    AUTORIZADO_CONSULTA: 'AUTORIZADO_CONSULTA',
    BENEFICIARIO: 'BENEFICIARIO',
    JUNTA_DIRECTIVA: 'JUNTA_DIRECTIVA',
    NUDO_PROPIETARIO: 'NUDO_PROPIETARIO',
    REPRESENTANTE_LEGAL: 'REPRESENTANTE_LEGAL',
    TITULAR: 'TITULAR',
    TUTOR: 'TUTOR',
    USUFRUCTUARIO: 'USUFRUCTUARIO'
};

const PP_ROLES = [
    'APORTANTE_CONYUGE',
    'APORTANTE_FAMILIAR',
    'BENEFICIARIO',
    'REPRESENTANTE_LEGAL',
    'TITULAR'
];
const FI_ROLES = [
    'ADMINISTRADOR',
    'APODERADO',
    'AUTORIZADO',
    'AUTORIZADO_CONSULTA',
    'JUNTA_DIRECTIVA',
    'NUDO_PROPIETARIO',
    'REPRESENTANTE_LEGAL',
    'TITULAR',
    'TUTOR',
    'USUFRUCTUARIO'
];

export const notExist = (others, ROLE) => {
    const roles = others.map(intervener => intervener.account_intervener_role.map(rol => rol.key));
    return roles.findIndex(x => x.includes(ROLE)) < 0;
};

export const mustExist = (others, ROLE) => {
    const roles = [];
    others.forEach(intervener =>
        intervener.account_intervener_role.map(rol => roles.push(rol.key))
    );
    return roles.includes(ROLE);
};

export const onlyOne = (others, ROLE) => {
    const roles = others.map(intervener => intervener.account_intervener_role.map(rol => rol.key));
    return roles.filter(x => x.includes(ROLE)).length === 1;
};

export const notBe = (me, ROLE) => {
    const roles = me.account_intervener_role.map(rol => rol.key);
    return !roles.includes(ROLE);
};

/**
 * Retorna roles en el caso de cuentas de tipo persona jurídica
 * @param {*} others otros intervinientes de la cuenta
 * @param {*} me interviniente actual
 * @return {*} roles
 */
export function canLPRoles(others, me) {
    const roleOptions = [];
    // ADMINISTRADOR
    // APODERADO
    if (!isMinor(me) && others.length >= 1) {
        roleOptions.push(roles.APODERADO);
    }
    // 'JUNTA_DIRECTIVA',
    // 'REPRESENTANTE_LEGAL'
    if (
        !isMinor(me) &&
        me.intervener_type === 'F' &&
        mustExist(others, roles.TITULAR) &&
        (mustExist(others, roles.ADMINISTRADOR) || mustExist(others, roles.APODERADO))
    ) {
        roleOptions.push(roles.JUNTA_DIRECTIVA);
        roleOptions.push(roles.REPRESENTANTE_LEGAL);
    }
    // TITULAR
    if (notExist(others, roles.TITULAR) && me.intervener_type === 'J') {
        roleOptions.push(roles.TITULAR);
    }

    return roleOptions;
}

/**
 * Retorna roles de personas físcas
 * @param {*} others otros intervinientes de la cuenta
 * @param {*} me interviniente actual
 * @return {*} roles
 */
export function canNPRoles(others, me) {
    const roleOptions = [];
    // TODO: quitar de aqui cuando se quite el rol
    // APORTANTES
    // if (
    //     !isMinor(me) &&
    //     (onlyOne(others, roles.TITULAR) || onlyOne(others, roles.NUDO_PROPIETARIO)) &&
    //     notExist(others, roles.APORTANTE_CONYUGE) &&
    //     notBe(me, roles.APORTANTE_FAMILIAR) &&
    //     notBe(me, roles.TITULAR)
    // ) {
    //     roleOptions.push(roles.APORTANTE_CONYUGE);
    // }
    // if (
    //     !isMinor(me) &&
    //     (onlyOne(others, roles.TITULAR) || onlyOne(others, roles.NUDO_PROPIETARIO)) &&
    //     notBe(me, roles.APORTANTE_CONYUGE) &&
    //     notBe(me, roles.TITULAR)
    // ) {
    //     roleOptions.push(roles.APORTANTE_FAMILIAR);
    // }
    // 'AUTORIZADO',
    if (
        !isMinor(me) &&
        notBe(me, roles.AUTORIZADO_CONSULTA) &&
        notBe(me, roles.TITULAR) &&
        notBe(me, roles.NUDO_PROPIETARIO) &&
        notBe(me, roles.USUFRUCTUARIO)
    ) {
        roleOptions.push(roles.AUTORIZADO);
    }
    // 'AUTORIZADO_CONSULTA)',
    if (
        !isMinor(me) &&
        notBe(me, roles.AUTORIZADO) &&
        notBe(me, roles.TITULAR) &&
        notBe(me, roles.NUDO_PROPIETARIO) &&
        notBe(me, roles.USUFRUCTUARIO)
    ) {
        roleOptions.push(roles.AUTORIZADO_CONSULTA);
    }
    // BENEFICIARIO
    // if (
    //     onlyOne(others, roles.TITULAR) &&
    //     notBe(me, roles.TITULAR)
    // ) {
    //     roleOptions.push(roles.BENEFICIARIO);
    // }
    // NUDO_PROPIETARIO
    if (
        !isMinor(me) &&
        notBe(me, roles.NUDO_PROPIETARIO) &&
        notBe(me, roles.USUFRUCTUARIO) &&
        notBe(me, roles.TITULAR) &&
        notExist(others, roles.TITULAR)
    ) {
        roleOptions.push(roles.NUDO_PROPIETARIO);
    }
    // REPRESENTANTE_LEGAL
    if (!isMinor(me) && others.length >= 1) {
        roleOptions.push(roles.REPRESENTANTE_LEGAL);
    }
    // TITULAR
    if (
        notExist(others, roles.NUDO_PROPIETARIO) &&
        notExist(others, roles.USUFRUCTUARIO) &&
        notBe(me, roles.TITULAR) &&
        notBe(me, roles.NUDO_PROPIETARIO) &&
        notBe(me, roles.USUFRUCTUARIO) &&
        notBe(me, roles.APORTANTE_CONYUGE) &&
        notBe(me, roles.APORTANTE_FAMILIAR)
    ) {
        roleOptions.push(roles.TITULAR);
    }
    // TUTOR
    if (others.some(x => isMinor(x)) && !isMinor(me)) {
        roleOptions.push(roles.TUTOR);
    } // USUFRUCTUARIO
    if (
        !isMinor(me) &&
        notBe(me, roles.USUFRUCTUARIO) &&
        notBe(me, roles.NUDO_PROPIETARIO) &&
        notBe(me, roles.TITULAR) &&
        notExist(others, roles.TITULAR) &&
        notExist(others, roles.USUFRUCTUARIO) &&
        onlyOne(others, roles.NUDO_PROPIETARIO)
    ) {
        roleOptions.push(roles.USUFRUCTUARIO);
    }
    return roleOptions;
}

/**
 * Devuelve los roles posibles
 * @param {*} accountTypes tipo de cuenta
 * @param {*} others los otros intervinientes
 * @param {*} me interviniente actual
 * @return {*} Listado de roles
 */
export function canRoles(accountTypes, others, me) {
    if (accountTypes === 'J') {
        return canLPRoles(others, me);
    }
    return canNPRoles(others, me);
}

/**
 * @override
 * @param {*} intervener interviniente
 * @param {*} now Ahora
 */
export function isMinor(intervener, now = moment()) {
    if (!intervener.birthdate) return false;

    return now.diff(moment(intervener.birthdate), 'years') < 18;
}

/**
 * @override
 * @param {*} document_expiration_date Fecha de cumpleaños
 * @param {*} now Ahora
 */
export function isDocumentExpired(document_expiration_date, now = moment()) {
    return now.isAfter(moment(document_expiration_date));
}

export function mappingRoles(availableRoles, suggestedRoles) {
    if (!availableRoles) return [];
    return suggestedRoles.filter(rol => availableRoles.includes(rol.key));
}

export function filterRolesByOperation(rolesSuggested, productType) {
    if (productType === 'P') return rolesSuggested.filter(rol => PP_ROLES.includes(rol.key));
    if (productType === 'F') return rolesSuggested.filter(rol => FI_ROLES.includes(rol.key));
    if (productType === 'ALL') return rolesSuggested;
}
